import Image from 'next/image';

import { clickLPConversionButton } from '@/utils/analytics/log-event';

import ConversionButton from './ConversionButton';
import headerLogo from './images/header/shakehands_logo.png';

type Props = {
  scrollToForm: () => void;
};

const Component: React.FC<Props> = ({ scrollToForm }) => {
  return (
    <div className="fixed z-50 flex w-full justify-center bg-white">
      <div className="mx-4 flex w-full max-w-[950px] items-center justify-between p-1">
        <div className="flex items-center">
          <Image src={headerLogo} alt="" className="h-8 w-auto md:h-[54px]" />

          <div className="ml-4 hidden text-xl font-bold text-gray-700 md:flex">
            プレミアムサービス
          </div>
        </div>

        <div className="flex items-center">
          <a
            href="https://my.shands.jp/users/sign_in"
            className="px-3 py-2 text-sm font-bold leading-none text-blue-900 underline"
          >
            会員ログイン
          </a>

          <div className="h-[40px] w-[136px] md:h-[45px] md:w-[150px] ">
            <ConversionButton
              useShortText
              scrollToForm={() => {
                scrollToForm();
                clickLPConversionButton('header');
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component;
